module.exports = __webpack_public_path__ + "a847303f8b88f4ff264146fd53e5313f.pdf";